import { ROUTE_CONSTANTS } from 'routing/router';

export const handleCheckIsChatPage = () => {
	return window.location.pathname === `${ROUTE_CONSTANTS.CABINET}${ROUTE_CONSTANTS.CHAT}`;
};